import { useCallback } from 'react';
import { useFax } from './FaxContext';

/**
 * Returns a single handler that runs print or fax with optional loading callbacks.
 * Use this instead of manually calling submitPrintOrFax + onBefore/onAfter at each call site.
 *
 * @param getPrintPromise - Function that performs the print API call with optional fax instructions.
 * @param onBefore - Optional; called before starting (e.g. setLoading(true)).
 * @param onAfter - Optional; called when the request settles (e.g. setLoading(false)).
 * @returns printOrFax(wantFax: boolean) to trigger print (false) or fax (true).
 */
export function usePrint(getPrintPromise, onBefore, onAfter) {
  const {
    submitPrintOrFax
  } = useFax();
  return useCallback(wantFax => {
    if (onBefore) onBefore();
    submitPrintOrFax({
      wantFax,
      getPrintPromise
    }).finally(() => {
      if (onAfter) onAfter();
    }).catch(() => {// Swallow so callers don't get unhandled rejections; onAfter already ran in finally
    });
  }, [submitPrintOrFax, getPrintPromise, onBefore, onAfter]);
}